import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-annotation', 'open', 'Open annotation');
Labels.set('ui-annotation', 'close', 'Close annotation');
